import React from 'react';
import { cn } from '../../lib/utils';

export function GroupBox({ label, children, className }) {
  return (
    <div className={cn("group-box", className)}>
      {label && <span className="group-box-label">{label}</span>}
      {children}
    </div>
  );
}
